module.exports = __webpack_public_path__ + "img/facebook.729d33bf.svg";